<style lang="stylus">
    .limitFilebox
        .limitFilebox-content
            display flex
            margin-bottom 32px

            .limitFilebox-smile
                margin-right 8px
                svg
                    stroke #222222

            .limitFilebox-text
                display flex
                flex-wrap wrap

                p
                    font-size 12px
                    color #222222

                p:not(:last-child)
                    margin-bottom 12px

        .limitFilebox-footer
            display flex
            justify-content flex-end
            div:not(:last-child)
                margin-right 16px
            pcStyleBtn()

        &.dark-theme__limitFilebox
            .limitFilebox-content
                .limitFilebox-smile
                    svg
                        stroke  #fff
                .limitFilebox-text
                    p
                        color #fff

    .limitmodal
        position fixed
        display flex
        justify-content center
        align-items center
        width 100vw
        height 100vh
        z-index 1010
        .limitmodal-mask
            modal-mask()
            position absolute
            z-index unset
        .limitmodal-box
            position relative
            width 480px
            min-height 440px
            background #fff
            box-shadow 0px 15px 30px rgba(0, 0, 0, 0.15)
            border-radius 8px
            z-index 1
            overflow hidden
            img
                display block
                width 100%
            .close-btn
                position absolute
                right 12px
                top 12px
                width 16px
                height 16px
                color #fff
                cursor pointer
            .bottom-box
                padding 24px 40px
                p
                    color #222222
                    font-size 16px
                    line-height 26px
                    font-weight 500
                    text-align center
                    margin-bottom 24px
                .bottom-btn
                    display flex
                    justify-content center
                    align-items center
                    width 100%
                    height 40px
                    border-radius 6px
                    color #000
                    font-size 14px
                    line-height 16px
                    user-select none
                    cursor pointer
                    &.vip
                        background: linear-gradient(90deg, #FFEF92 0%, #FFD67B 100%)
                        color #402300
                        font-weight 600
                        margin-bottom 12px
                        &:hover
                            background: linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), linear-gradient(90deg, #FFEF92 0%, #FFD67B 100%)
                    &.white
                        height 24px
                        &:hover
                            color rgba(0, 0, 0, 0.5)
        &.dark-theme__limitmodal
            .limitmodal-box
                background #3F3F41
                p
                    color #fff
                .bottom-btn
                    &.white
                        color #fff
                        &:hover
                            color rgba(255, 255, 255, 0.5)
</style>
<template>
    <!-- <PCStyleModal @closeModal="closeModal" :title="$t('title')" :width="modalWidth">
        <div class="limitFilebox" :class="{'dark-theme__limitFilebox': isPCDarkMode == 2}">
            <div class="limitFilebox-content">
                <div class="limitFilebox-smile">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 29C23.1797 29 29 23.1797 29 16C29 8.82029 23.1797 3 16 3C8.82029 3 3 8.82029 3 16C3 23.1797 8.82029 29 16 29Z" stroke="inherit" stroke-width="2" stroke-linejoin="round"/>
                        <path d="M21 20C21 20 19.5714 23 16 23C12.4286 23 11 20 11 20" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.0039 13.5C14.0039 13.5 13.3164 11 11.2539 11C9.19141 11 8.50391 13.5 8.50391 13.5" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M23.5 13.5C23.5 13.5 22.8125 11 20.75 11C18.6875 11 18 13.5 18 13.5" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="limitFilebox-text">
                    <p>{{ $t('tips1', {fileNum: limitFileNum}) }}</p>
                    <p style="line-height: 20px">{{ limitFileModalType == 'save' ? $t('tips2-1', {fileNum: limitFileNum}) : $t('tips2', {fileNum: limitFileNum}) }}</p>
                    <p v-html="$t('tips3')"></p>
                </div>
            </div>

            <div class="limitFilebox-footer">
                <div v-if="!isTeamsApp" class="pcstyle-btn vip-btn" @click="toVip">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 18C11 18.5523 10.5523 19 10 19C9.44772 19 9 18.5523 9 18C9 17.4477 9.44772 17 10 17C10.5523 17 11 17.4477 11 18Z" fill="#4A320E"/>
                        <path d="M17 18C17 18.5523 16.5523 19 16 19C15.4477 19 15 18.5523 15 18C15 17.4477 15.4477 17 16 17C16.5523 17 17 17.4477 17 18Z" fill="#4A320E"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4 5.5C4 5.22386 4.22386 5 4.5 5H6.64632C7.12513 5 7.53675 5.33941 7.62799 5.80945L9.33342 14.5954C9.37904 14.8304 9.58485 15.0001 9.82426 15.0001L17.5 15C17.7761 15 18 15.2238 18 15.5C18 15.7761 17.7762 16 17.5 16L9.82428 16.0001C9.10605 16.0001 8.4886 15.491 8.35174 14.786L6.64632 6H4.5C4.22386 6 4 5.77614 4 5.5Z" fill="#4A320E"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4098 8H7.5V7H18.4098C19.0277 7 19.4978 7.55487 19.3962 8.1644L18.6325 12.7466C18.5119 13.4699 17.8861 14 17.1529 14H9V13H17.1529C17.3973 13 17.6059 12.8233 17.6461 12.5822L18.4098 8Z" fill="#4A320E"/>
                    </svg>
                    <p>{{ $t('confirm') }}</p>
                </div>
                <div class="pcstyle-btn gray-btn" @click="continueCreate"><p>{{ limitFileModalType == 'save' ? $t('cancel2') : $t('cancel') }}</p></div>
            </div>
        </div>
    </PCStyleModal> -->
    <div class="limitmodal" :class="{ 'dark-theme__limitmodal': isPCDarkMode == 2, noMask: isPC }">
        <div class="limitmodal-mask"></div>
        <div class="limitmodal-box">
            <img src="@/home/assets/img/filelimit-bg.png" alt="" />
            <iconSymbol class="close-btn" name="close" @click.native="closeModal" />
            <div class="bottom-box">
                <p>{{ limitFileModalType == "save" ? $t("tips4", { fileNum: limitFileNum }) : $t("tips4", { fileNum: limitFileNum }) }}</p>
                <div class="bottom-btn vip" @click="toVip">{{ $t("confirm") }}</div>
                <div class="bottom-btn white" @click="continueCreate">{{ limitFileModalType == "save" ? $t("cancel2") : $t("cancel") }}</div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import PCStyleModal from "@/home/parts/vip/PCStyleModal.vue";
    @Component({
        components: {
            PCStyleModal,
        },
    })
    export default class limitFileModal extends Vue {
        isLoading: boolean = false;
        isInDragbox: boolean = false;
        lastEnterEle = null;
        uploadState = false;
        uploadFilePath = "";
        pollingCount: number = 0;
        importType = "";
        importFileType = "";

        closeModal() {
            this.close();
        }

        close() {
            this.showLimitFileModal = false;
            this.$bus.$off("limitModalContinue");
            this.$store.commit("setState", {
                type: "limitFileModalFlag",
                data: true,
            });
            this.sensors.track("closeUpgardePlanTip", {
                Catalogues: "payPath",
                upgrade_trigger: "cloudFileNumberLimit",
            });
        }
        get modalWidth() {
            if (this.lang == "zh") {
                return 480;
            } else {
                return "";
            }
        }
        get limitFileNum() {
            return this.$store.state.limitFileNum || 3;
        }
        get showLimitFileModal() {
            return this.$store.state.showLimitFileModal;
        }
        set showLimitFileModal(v) {
            this.$store.commit("setState", {
                type: "showLimitFileModal",
                data: v,
            });
        }
        get limitFileModalType() {
            return this.$store.state.limitFileModalType;
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        toVip() {
            this.sensors.track("fileUpgrade", {
                Catalogues: "openFileProcess",
                click_file_button: "upgrade",
            });
            this.sensors.track("clickGoUpgrade", {
                Catalogues: "payPath",
                upgrade_trigger: "cloudFileNumberLimit",
            });
            if (!this.internal && this.lang == "en") {
                this.$store.commit("toPublicStatus", {
                    type: "upgradeTrigger",
                    data: "cloudFilePop",
                });
                this.$bus.$emit("togglePromodal", true, 0, 2);
            } else {
                this.$openBuyPage("cloudFilePop");
            }
            this.close();
        }

        continueCreate() {
            this.sensors.track("fileUpgrade", {
                Catalogues: "openFileProcess",
                click_file_button: "continue",
            });
            this.showLimitFileModal = false;
            this.$bus.$emit("limitModalContinue");
        }

        created() {}
        keyEvent(e) {
            if (e.keyCode == 27) {
                // esc
                this.closeModal();
            }
        }
        mounted() {
            this.sensors.track("popUpgradePlanTip", {
                Catalogues: "payPath",
                upgrade_trigger: "cloudFileNumberLimit",
            });
            document.addEventListener("keydown", this.keyEvent);
        }
        beforeDestroy() {
            this.$store.commit("setState", {
                type: "limitFileModalType",
                data: "create",
            });
            document.removeEventListener("keydown", this.keyEvent);
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "升级提示",
    "tips1": "你现在为非会员账号，仅可创建{fileNum}个可编辑的文件。",
    "tips2": "若你仍然需要创建文件，你将只能编辑最近创建的{fileNum}个文件，其余的文件将会变为仅查看的状态。",
    "tips2-1": "若你仍然需要保存文件，你将只能编辑最近创建的{fileNum}个云文件，其余的文件将无法编辑。",
    "tips3": "开通VIP即可创建<b>无限制的可编辑云文件</b>",
    "tips4": "非会员只能编辑最近创建的{fileNum}个云文件，其余的云文件将变为仅查看状态",
    "confirm": "开通VIP",
    "cancel": "继续创建",
    "cancel2": "继续保存"
  },
  "en": {
    "title": "Upgrade Reminder",
    "tips1": "With the Free version, you can only create {fileNum} editable Cloud Document(s).",
    "tips2": "If you continue creating documents, you will only be able to edit the {fileNum} most recently created Cloud Document(s). The rest will be view-only.",
    "tips2-1": "If you continue saving documents, you will only be able to edit the {fileNum} most recently created Cloud Document(s). The rest will be view-only.",
    "tips3": "Upgrade to Premium to create and <b>edit unlimited Cloud Documents.</b>",
    "tips4": "The {fileNum} most recently created files will be editable, while all the rest will be view-only in current plan",
    "confirm": "Start free trial for unlimited edit",
    "cancel": "Create a file anyway",
    "cancel2": "Save"
  },
  "es": {
    "title": "Recordatorio de Actualización",
    "tips1": "Con la versión Gratis, solo puede crear {fileNum} documentos en la nube editables.",
    "tips2": "Si sigue creando documentos, solo podrá editar los {fileNum} documentos en la nube creados más recientemente. El resto serán solo para su visualización.",
    "tips2-1": "Si sigue guardando documentos, solo podrá editar los {fileNum} documentos en la nube creados más recientemente. El resto serán solo para su visualización.",
    "tips3": "Actualice a Premium para crear y <b>editar documentos en la nube de forma ilimitada.</b>",
    "tips4": "El plan gratuito solo permite editar {fileNum} documentos creados recientemente en la nube. El resto solo podrán visualizarse.",
    "confirm": "Actualizar Ahora",
    "cancel": "Crear",
    "cancel2": "Guardar"
  },
  "jp": {
    "title": "アップグレードの通知",
    "tips1": "無料バージョンでは、編集可能なクラウドドキュメントを {fileNum} 個のみ作成できます。",
    "tips2": "ドキュメントの作成を続行する場合は、最近作成した {fileNum} 個のクラウドドキュメントのみを編集できます。残りのクラウドドキュメントは表示専用になります。 ",
    "tips2-1": "ドキュメントの保存を続行する場合は、最近作成した {fileNum} 個のクラウドドキュメントのみを編集できます。残りのクラウドドキュメントは表示専用になります。",
    "tips3": "<b>クラウドドキュメントを制限なく作成および編集</b>するには、プレミアムにアップグレードしてください。",
    "tips4": "無料プランでは、直近に作成されたクラウドドキュメントを{fileNum}個のみ編集できます。それ以外は閲覧限定です。",
    "confirm": "今すぐアップグレード",
    "cancel": "作成",
    "cancel2": "保存"
  },
  "fr": {
    "title": "Rappel de mise à niveau",
    "tips1": "Avec la version gratuite, vous ne pouvez créer que {fileNum} document(s) cloud modifiable(s).",
    "tips2": "Si vous continuez à créer des documents, vous ne pourrez éditer que les {fileNum} derniers documents cloud créés. Le reste des documents sera en lecture seule.",
    "tips2-1": "Si vous continuez à enregistrer des documents, vous ne pourrez éditer que les {fileNum} derniers documents cloud créés. Le reste des documents sera en lecture seule.",
    "tips3": "Passez à la version Premium pour créer et <b>modifier un nombre illimité de documents cloud.</b>",
    "tips4": "Le forfait gratuit ne permet de modifier que {fileNum} document(s) cloud récemment créé(s), les autres sont en lecture seule.",
    "confirm": "Mettre à niveau maintenant",
    "cancel": "Créer",
    "cancel2": "Enregistrer"
  },
  "pt": {
    "title": "Lembrete de Atualização",
    "tips1": "Com a versão gratuita, você só pode criar {fileNum} documento(s) na nuvem editável(is).",
    "tips2": "Se você continuar criando documentos, poderá editar somente o(s) {fileNum} documento(s) na nuvem criado(s) mais recentemente. Os demais documentos podem ser visualizados apenas.",
    "tips2-1": "Se você continuar salvando documentos, poderá editar somente o(s) {fileNum} documento(s) na nuvem criado(s) mais recentemente. Os demais documentos podem ser visualizados apenas.",
    "tips3": "Atualize para a versão Premium para criar e <b>editar documentos na nuvem sem limites.</b>",
    "tips4": "O plano gratuito permite editar apenas {fileNum} documentos em nuvem recém-criados, outros serão somente para visualização.",
    "confirm": "Atualize Agora",
    "cancel": "Criar",
    "cancel2": "Salvar"
  },
  "de": {
    "title": "Promemoria di Aggiornamento",
    "tips1": "Mit der kostenlosen Version können Sie nur {fileNum} bearbeitbare(s) Cloud-Dokument(e) erstellen.",
    "tips2": "Wenn Sie mit dem Erstellen von Dokumenten fortfahren, können Sie nur {fileNum} Cloud-Dokument(e) bearbeiten, die zuletzt erstellt wurden. Alle anderen Dokumente sind dann nur noch zur Ansicht verfügbar.",
    "tips2-1": "Wenn Sie mit dem Speichern von Dokumenten fortfahren, können Sie nur {fileNum} Cloud-Dokument(e) bearbeiten, die zuletzt erstellt wurden. Alle anderen Dokumente sind dann nur noch zur Ansicht verfügbar.",
    "tips3": "Führen Sie ein Upgrade auf Premium durch, um <b>Cloud-Dokumente uneingeschränkt erstellen und bearbeiten zu können.</b>",
    "tips4": "El plan gratuito solo permite editar {fileNum} documentos creados recientemente en la nube. El resto solo podrán visualizarse.",
    "confirm": "Jetzt upgraden",
    "cancel": "Erstellen",
    "cancel2": "Speichern"
  },
  "it": {
    "title": "Promemoria di Aggiornamento",
    "tips1": "Con la versione gratuita, puoi creare solo {fileNum} documenti per il cloud modificabili.",
    "tips2": "Se continui a creare documenti, potrai modificare solo i documenti per il cloud creati più di recente ({fileNum}). Gli altri saranno disponibili per la sola visualizzazione.",
    "tips2-1": "Se continui a salvare documenti, potrai modificare solo i documenti per il cloud creati più di recente ({fileNum}). Gli altri saranno disponibili per la sola visualizzazione.",
    "tips3": "Passa alla versione Premium per creare e <b>modificare un numero illimitato di documenti per il cloud</b>.",
    "tips4": "Con il piano gratuito è possibile modificare solo {fileNum} documenti cloud creati di recente, gli altri saranno di sola visualizzazione.",
    "confirm": "Aggiorna Ora",
    "cancel": "Crea",
    "cancel2": "Salva"
  },
  "tw": {
    "title": "升级提示",
    "tips1": "使用免費版本時，您只能建立 {fileNum} 份可編輯的雲端文件。",
    "tips2": "如果您繼續建立文件，將僅能編輯最近建立的 {fileNum} 份雲端文件。其餘則僅供檢視。",
    "tips2-1": "如果您繼續儲存文件，將僅能編輯最近建立的 {fileNum} 份雲端文件。其餘則僅供檢視。",
    "tips3": "升級至 Premium 以建立和<b>編輯無上限的雲端文件</b>。",
    "tips4": "免費方案僅能編輯 {fileNum} 份最近建立的雲端文件，其他則僅供檢視。",
    "confirm": "升级会员",
    "cancel": "继续创建",
    "cancel2": "继续保存"
  },
  "kr": {
    "title": "업그레이드 알림",
    "tips1": "무료 버전에서는 편집 가능한 클라우드 문서 {fileNum}개만 생성할 수 있습니다.",
    "tips2": "문서를 계속 생성하면 가장 최근에 생성된 클라우드 문서 {fileNum}개만 편집할 수 있습니다. 나머지는 보기 전용입니다.",
    "tips2-1": "문서를 계속 저장하면 가장 최근에 생성된 클라우드 문서 {fileNum}개만 편집할 수 있습니다. 나머지는 보기 전용입니다.",
    "tips3": "프리미엄으로 업그레이드하여 <b>무제한 클라우드 문서 생성 및 편집</b>을 이용하십시오.",
    "tips4": "무료 요금제로는 최근에 생성한 클라우드 문서 {fileNum}개만 편집할 수 있으며, 다른 문서는 보기 전용으로 이용할 수 있습니다.",
    "confirm": "지금 업그레이드하기",
    "cancel": "만들기",
    "cancel2": "저장하기"
  },
  "id": {
    "title": "Pengingat Peningkatan",
    "tips1": "Saat ini Anda menggunakan akun gratis dan hanya dapat membuat {fileNum} file yang dapat diedit.",
    "tips2": "Untuk melanjutkan penyimpanan file, hanya {fileNum} file terbaru yang dapat diedit. Sisanya tidak akan dapat dibuka.",
    "tips2-1": "Jika Anda melanjutkan menyimpan dokumen, Anda hanya akan dapat mengedit {fileNum} Dokumen Cloud yang paling baru dibuat. Sisanya hanya dapat dilihat.",
    "tips3": "Tingkatkan ke Premium untuk membuat dan <b>mengedit Dokumen Cloud tak terbatas</b>.",
    "tips4": "Paket gratis hanya dapat mengedit {fileNum} Dokumen Cloud yang baru dibuat, sedangkan lainnya hanya dapat dilihat.",
    "confirm": "Tingkatkan Sekarang",
    "cancel": "Buat",
    "cancel2": "Simpan"
  }
}
</i18n>
